export const version = '2.56.0';
//# sourceMappingURL=version.js.map